import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { MatDialog } from '@angular/material/dialog';
import { CreateBatchDialogComponent } from '../create-batch-dialog/create-batch-dialog.component';
import { Router } from '@angular/router';
import { BatchManagementService } from '@edtech-ui/core/services/batch-management/batch-management.service';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { AllTenantsBatchData } from '@edtech-ui/core/models/admin-panel/batch-management/get-all-tenants-batches';
import { ToastrService } from 'ngx-toastr';
import { IstDatePipe } from '@edtech-ui/core/models/Classroom/ist-date.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
	selector: 'app-batch-management-landing',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatIconModule,
		MatCardModule,
		MatChipsModule,
		ButtonModule,
		TagModule, IstDatePipe,MatProgressSpinnerModule,AdminHeaderComponent
	],
	templateUrl: './batch-management-landing.component.html',
	styleUrl: './batch-management-landing.component.scss'
})
export class BatchManagementLandingComponent implements OnInit, OnDestroy {
	batchData: AllTenantsBatchData[] = [];
	batchCount: number = 0;
	subscription = new Subscription();
	isLoading= false;
	tenantName='Batch Management';
	tenantSubName='Manage student batches';

	constructor(
		private dialog: MatDialog,
		private router: Router,
		private _batchService: BatchManagementService,
		private _toastr: ToastrService,
	) {
		this.subscription.add(this._batchService.reload$.pipe(tap(() => this.getAllTenantsBatches())).subscribe());
	}

	ngOnInit() {
		this.getAllTenantsBatches();
 }

	onCreateBatch() {
		this.subscription.add(
		this.dialog.open(CreateBatchDialogComponent, {
			width: '500px',
			maxWidth: '95vw',
			panelClass: 'custom-dialog-container',
			disableClose: true
		}).afterClosed().subscribe(result => {
			if (result) {
				this.getAllTenantsBatches();
			}
		})
	)
	}

	navigateToStudentsStats(batchId: number) {
		this.router.navigate(['/admin-dashboard/students-stats', batchId,]);
	}

	getAllTenantsBatches() {
		this.isLoading = true;
		this, this.subscription.add(
			this._batchService.getAllTenantsBatches().pipe(
				tap(response => {
					if (response.Success) {
						this.batchData = response.Data.batches;
						this.batchCount = response.Data.total_count;
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(()=>{
					this.isLoading =false
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching batches');
					return of(null);
				})
			).subscribe());
	}

	deleteBatches(batchId: number) {
		this.subscription.add(
			this._batchService.deleteAllBatches(batchId).pipe(
				tap(response => {
					if (response.Success) {
						this._toastr.success(response.Message);
						this.getAllTenantsBatches();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong.Please try again');
					return of(null);
				})
			).subscribe()
		);
	}

	onEditBatchDialogBox(batch: AllTenantsBatchData) {
		this.subscription.add(
		this.dialog.open(CreateBatchDialogComponent, {
			width: '500px',
			maxWidth: '95vw',
			panelClass: 'custom-dialog-container',
			disableClose: true,
			data: batch
		}).afterClosed().subscribe(result => {
			if (result) {
				this.getAllTenantsBatches();
			}
		})
	);
	}

	openDeleteBatchDialogBox(batchId: number, batchName: string) {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '32rem',
			maxWidth: '95vw',
			panelClass: 'custom-dialog-container',
			data: {
				title: 'Delete Batch?',
				message: `This will permanently delete the batch ${batchName}. This action cannot be undone.`,
				confirmText: 'Delete',
				cancelText: 'Cancel',
				entityName: batchName
			}
		});
		dialogRef.afterClosed().subscribe((confirmed) => {
			if (confirmed) {
				this.deleteBatches(batchId);
			}
		})
	}

	convertToIST(utcDateString: string): string {
		if (!utcDateString) return '';
		const date = new Date(utcDateString);
		return new Intl.DateTimeFormat('en-IN', {
			timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short'
		}).format(date);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}